import { useCallback, useEffect, useState } from "react";

const initialData = { Collection: [], Total: 0 };

export const useGetAdminMessagesTableData = (filter, ajax) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const [data, setData] = useState(initialData);

  useEffect(
    () => {
      fetchData();
    },
    [filter]
  );

  const fetchData = useCallback(
    async () => {
      try {
        setError(undefined);
        setIsLoading(true);
        const response = await getAdminMessagesApiCall(filter, ajax);
        setData(response);
      } catch (err) {
        setData(initialData);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    },
    [filter, ajax]
  );

  return {
    data,
    isLoading,
    error,
  };
};

const getAdminMessagesApiCall = (filter, ajax) => {
  const query = "?" + new URLSearchParams(filter).toString();
  return ajax.getPromise(`adminMessages/filter${query}`, true, true);
};
